import styled from 'styled-components';

/**
 * @deprecated use gen.2 Typography instead
 */
const H4 = styled.h4`
  font-size: 26px;
  margin: 0;
  font-weight: 700;
`;

export default H4;
